<template>
  <div class="container mt-6">
    <vs-card :title="'Catálogos'">
      <vs-table :data="catalogs" stripe>
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap mb-2 float-right">
            <vs-button
              @click="showModal = true"
              color="green" class="mr-2">Crear nuevo registro
            </vs-button>
          </div>
        </div>

        <template slot="thead">
          <vs-th>Categoría</vs-th>
          <vs-th>Descripción</vs-th>
          <vs-th>Calificación</vs-th>
          <vs-th>Creación</vs-th>
          <vs-th>Última actualización</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="item in data" :key="item.id">
            <vs-td>{{ item.category }}</vs-td>
            <vs-td>{{ item.description }}</vs-td>
            <vs-td>
              <edit-text-component
                @keyup.native.enter="updatePercentage(item)"
                v-model="item.percentage"></edit-text-component>
            </vs-td>
            <vs-td>{{ item.created_at }}</vs-td>
            <vs-td>{{ item.updated_at }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>


    <vs-popup
      :active.sync="showModal"
      :title="'Crear nuevo valor de catalogo'">
      <form>
        <vs-input
          class="w-full"
          v-model="newItem.description"
          label="Descripción"></vs-input>

        <vs-input
          class="w-full"
          v-model="newItem.percentage"
          label="Calificación"></vs-input>

        <vs-select
          label="Categoría"
          class="w-full"
          v-model="newItem.categorySelected">

          <vs-select-item
            v-for="category in categories"
            :value="category.category"
            :key="category.id"
            :text="category.category"></vs-select-item>

          <!-- Opción para crear una nueva categoría -->
          <vs-select-item value="new" text="Crear nuevo"></vs-select-item>
        </vs-select>

        <vs-input
          class="w-full"
          label="Nueva categoría"
          v-if="newItem.categorySelected === 'new'"
          v-model="newItem.category"></vs-input>

        <vs-button
          class="mt-6"
          @click="createNewItem">
          Guardar
        </vs-button>
      </form>
    </vs-popup>

  </div>
</template>

<script>
import {RiskModel} from "@/services/ModelRisk/RiskModel";
import EditTextComponent from "@components/editText/EditTextComponent";

export default {
  name: "Index",
  components: {EditTextComponent},
  data: () => ({
    currentCatalog: {
      id: "",
      category: ""
    },
    catalogs: [],
    categories: [],
    newItem: {
      categorySelected: "",
      category: "",
      description: "",
      percentage: 0
    },
    showModal: false
  }),
  async mounted() {
    this.currentCatalog.id = this.$route.params.id;
    if (this.$route.query.category) {
      this.currentCatalog.category = this.$route.query.category;
      // set default category on modal
      this.newItem.categorySelected = this.currentCatalog.category;
    }


    this.catalogs = await RiskModel
      .catalog()
      .getItemsByCategory(this.$route.params.id)

    this.categories = await RiskModel.catalog()
      .categories();
  },
  methods: {
    async createNewItem() {
      if (this.newItem.categorySelected !== "new") {
        this.newItem.category = this.newItem.categorySelected;
      }

      let catalog = await RiskModel.catalog()
        .create(
          this.newItem.category,
          this.newItem.description,
          this.newItem.percentage,
        )

      this.catalogs.push(catalog)
    },
    updatePercentage(item) {
      alert()
    }
  }
}
</script>

<style scoped>

</style>
